import React, { useState, useEffect } from 'react';
import { StyleSheet, Platform } from 'react-native';
import { usePathname } from 'expo-router';
import { useTranslation } from '@/hooks/useTranslation';
import * as DropdownMenu from '@/components/DropdownMenu/DropdownMenu';
import NavigationBarButton from '@/components/Navigation/NavigationBarButton';
import { Link } from 'expo-router';
import { useTheme } from '@/context/ThemeContext';

// Create styles outside component
const createStyles = (colors) => StyleSheet.create({
  menuItem: {
    paddingVertical: 8,
    paddingHorizontal: 12,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  menuItemText: {
    color: colors.text_color_primary,
    fontSize: 14,
  }
});

const InfoSelector = () => {
  const { colors } = useTheme();
  const { t } = useTranslation();
  const pathname = usePathname();
  const [isOpen, setIsOpen] = useState(false);

  // Close dropdown when route changes
  useEffect(() => {
    setIsOpen(false);
  }, [pathname]);

  const styles = React.useMemo(() => createStyles(colors), [colors]);

  const menuItems = [
    { title: t('nav.infoSelector.about'), href: '/about' },
    { title: t('nav.infoSelector.contact'), href: '/contact' },
    { title: t('nav.infoSelector.termsOfService'), href: '/terms-of-service' },
    { title: t('nav.infoSelector.termsOfSale'), href: '/terms-of-sale' },
    { title: t('nav.infoSelector.privacyPolicy'), href: '/privacy-policy' },
    { title: t('nav.infoSelector.feedback'), href: '/feedback' },
  ];

  return (
    <DropdownMenu.Root open={isOpen} onOpenChange={setIsOpen}>
      <DropdownMenu.Trigger asChild={Platform.OS === 'web' || Platform.OS === 'macos'}>
        <NavigationBarButton 
          icon='circle-question'
          title={t('nav.infoSelector.title')}
          tooltip={t('nav.infoSelector.title')}
          hoverBackgroundColor={colors.solid_color_tertiary}
          isActive={isOpen}
        />
      </DropdownMenu.Trigger>
      <DropdownMenu.Content className="DropdownMenuContent" style={{ minWidth: 200 }}>
        {menuItems.map((item, index) => (
          <Link key={`info-selector-item-${index}`} href={item.href} asChild>
            <DropdownMenu.Item className="DropdownMenuItem" style={styles.menuItem}>
              <DropdownMenu.ItemTitle className="DropdownMenuItemTitle" style={styles.menuItemText}>
                {item.title}
              </DropdownMenu.ItemTitle>
            </DropdownMenu.Item>
          </Link>
        ))}
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
};

InfoSelector.displayName = 'InfoSelector';

export default React.memo(InfoSelector);
